<!-- 人选进展弹层 在用 -->
<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
      top="60px"
      :title="radish.姓名"
      class="rpg-dialog rpg-dialog-noline"
      @close="close"
    >
      <div
        v-if="showIntoProject"
        slot="title"
        class="el-dialog__title"
      >
        {{ radish.姓名 }}
        <el-button
          type="primary"
          size="mini"
          style="margin-left: 20px;"
          @click="intoProject"
        >加入项目</el-button>
      </div>
      <div>
        <template v-if="!logOnly">
          <div>
            <span> {{ project.客户公司 }} {{ project.部门 }} {{ project.项目名称 }} </span>
          </div>
          <div
            v-if="progress.标签 != 'Call'"
            style="text-align:right"
          >
            <el-button
              type="text"
              @click="showAll"
            > 查看该阶段所有人选 </el-button>
          </div>
          <div class="rpg-progress">
            <div class="rpg-line"></div>
            <div class="rpg-dots">
              <div
                v-for="(num, word) in progresses"
                :key="num"
                class="rpg-dot-item"
              >
                <div
                  class="rpg-dot"
                  :class="dotClass(num)"
                ></div>
                <div class="rpg-word">{{ word }}</div>
              </div>
            </div>
          </div>
        </template>
        <div class="rpg-content">
          <div
            v-if="!logOnly && hasPermisson()"
            class="rpg-actions"
          >
            <div
              class="rpg-btn"
              type="primary"
              @click="openQuickChat"
            >快速沟通</div>
            <template v-if="progress.isFail">
              <div
                class="rpg-btn"
                type="primary"
                @click="reStart"
              >重启人选</div>
            </template>
            <template v-else>
              <template v-if="currentProgress == 1">
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('RecommendCreate')"
                >推荐给客户</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="genRepo"
                >制作推荐报告</div>
              </template>
              <template v-else-if="currentProgress == 2">
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="genRepo"
                >制作推荐报告</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('RecommendFeedback')"
                >推荐反馈</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="cancelRecommend"
                >取消推荐</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('InterviewCreate')"
                >安排面试</div>
              </template>
              <template v-else-if="currentProgress == 3">
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('InterviewFeedback')"
                >面试反馈</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('InterviewGuide')"
                >面试辅导</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('InterviewCreate')"
                >安排下一轮面试</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('InterviewEdit')"
                >修改面试</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="cancelInterview"
                >取消面试</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="interviewCreateFinal"
                >终面</div>
              </template>
              <template v-else-if="currentProgress == 4">
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('InterviewFeedback')"
                >面试反馈</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('InterviewGuide')"
                >面试辅导</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="cancelInterview"
                >取消面试</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('BackgroundResearch')"
                >背景调查</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('OfferMaybe')"
                >拟offer</div>
                <div
                  class="rpg-btn"
                  @click="showDia('InterviewCreate')"
                >安排面试</div>
              </template>
              <template v-else-if="currentProgress == 5">
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('InterviewFeedback')"
                >面试反馈</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('InterviewGuide')"
                >面试辅导</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('BackgroundResearch')"
                >背景调查</div>
                <!-- <div class="rpg-btn" type="primary" @click="showDia('OfferConfirm')">offer确认</div> -->
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showYejifenchengDia()"
                >offer确认</div>
                <div
                  class="rpg-btn"
                  @click="showDia('OfferFeedback')"
                >offer反馈</div>
                <div
                  class="rpg-btn"
                  @click="offerFeedbackGiveup"
                >人选放弃</div>
                <div
                  class="rpg-btn"
                  @click="showDia('InterviewCreate')"
                >安排面试</div>
              </template>
              <template v-else-if="currentProgress == 6">
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('LeaveGuide')"
                >离职辅导</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('OfferEdit')"
                >修改offer</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('BackgroundResearch')"
                >背景调查</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('ToworkConfirm')"
                >确认到岗</div>
                <div
                  class="rpg-btn"
                  @click="showDia('ToworkNot')"
                >未入职</div>
              </template>
              <template v-else-if="currentProgress == 7">
                <div
                  v-if="!progress.状态.detail || progress.状态.detail == '未开票' || progress.状态.detail == '开票中'"
                  class="rpg-btn"
                  type="primary"
                  @click="makePayDoc"
                >
                  {{ !progress.状态.detail ? '制作付款通知书' : '重新制作付款通知书' }}
                </div>
                <div
                  v-if="progress.状态.detail == '未开票'"
                  class="rpg-btn"
                  type="primary"
                  @click="kaipiao"
                >开票</div>
                <div
                  class="rpg-btn"
                  type="primary"
                  @click="showDia('WarrantyConfirm')"
                >确认过保</div>
                <div
                  class="rpg-btn"
                  @click="showDia('WarrantyNot')"
                >未过保</div>
              </template>
              <template v-else-if="currentProgress == 8">
                <div
                  v-if="
                    progress.状态.detail == '需开票' ||
                      progress.状态.detail == '未开票' ||
                      progress.状态.detail == '开票中'
                  "
                  class="rpg-btn"
                  type="primary"
                  @click="makePayDoc2"
                >
                  {{ progress.状态.detail == '需开票' ? '制作二期付款通知书' : '重新制作二期付款通知书' }}
                </div>
                <div
                  v-if="progress.状态.detail == '未开票'"
                  class="rpg-btn"
                  type="primary"
                  @click="kaipiao"
                >开票</div>
              </template>
              <el-popover
                v-if="currentProgress == 2 || currentProgress == 3 || currentProgress == 4"
                placement="bottom"
                width="800"
                trigger="click"
              >
                <div>
                  <p>
                    请点击勾选O，选择你要使用的项目报告类型：<peixun
                      type="10"
                      style="display:inline-block;margin-left:5px;position:relative;top:3px;"
                    ></peixun>
                  </p>
                  <div class="flex-row">
                    <div
                      class="col-1 pd10"
                      @click="reportType = 'mapping'"
                    >
                      <el-radio
                        v-model="reportType"
                        label="mapping"
                      >人选mapping报告</el-radio>
                      <p class="ft-gray">自行选择需要的人选字段，并形成报告。</p>
                      <div><img
                          src="../../../assets/images/project_mapping.png"
                          class="img_max"
                        /></div>
                    </div>
                    <div
                      class="col-1 pd10"
                      @click="reportType = 'report'"
                    >
                      <el-radio
                        v-model="reportType"
                        label="report"
                      >搜索进度报告</el-radio>
                      <p class="ft-gray">根据项目推进情况，自动进行统计，形成进度报告。</p>
                      <div><img
                          src="../../../assets/images/project_report.png"
                          class="img_max"
                        /></div>
                    </div>
                  </div>
                  <div class="text_right">
                    <!-- <a :href="`#/project/${pid}/${reportType}`" class="btn_default" target="_blank">生成报告</a> -->
                    <span
                      class="btn_default"
                      @click="getReport"
                    >生成报告</span>
                  </div>
                </div>
                <div
                  slot="reference"
                  class="rpg-btn"
                >生成市场报告</div>
              </el-popover>
            </template>
          </div>
          <div class="rpg-logs">
            <div class="rpg-logs-title">人选项目进展日志</div>
            <el-timeline>
              <el-timeline-item
                v-for="(log, index) in logs"
                :key="index"
                placement="top"
                :timestamp="log.timestamp"
              >
                <div>
                  <el-badge
                    :hidden="!(!log.more && log.badge)"
                    is-dot
                    class="radish-progress-dot"
                  >
                    <span
                      style="margin-top:5px"
                      @click="removeBadge(log)"
                    >{{ log.title }}</span>
                  </el-badge>
                </div>
                <div v-html="log.content"></div>
                <div v-if="log.more">
                  <el-popover
                    placement="top"
                    trigger="click"
                    width="500"
                  >
                    <div
                      style="font-size: 12px;line-height:1.5"
                      v-html="formatStr(log.more)"
                    ></div>
                    <span
                      slot="reference"
                      class="rpg-btn-text"
                    >
                      <!-- <el-badge :hidden="!log.badge" is-dot> -->
                      <el-badge
                        :hidden="!log.badge"
                        is-dot
                        class="radish-progress-dot"
                      >
                        <span
                          style="margin-top:5px"
                          @click="removeBadge(log)"
                        >查看详情</span>
                      </el-badge>
                    </span>
                    <!-- <span slot="reference" class="rpg-btn-text">查看详情</span> -->
                  </el-popover>
                </div>
                <span
                  v-if="log.type == '发起offer'"
                  class="rpg-btn-text"
                  @click="showOffer"
                >查看详情</span>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
    </el-dialog>
    <QuickChat
      ref="QuickChat"
      :on-confirm="diaConfirm"
    ></QuickChat>
    <ProgressDia
      ref="ProgressDia"
      :on-confirm="diaConfirm"
    ></ProgressDia>
    <YejifenchengDia
      ref="YejifenchengDia"
      @onConfirm="yejiConfirm"
    ></YejifenchengDia>
  </div>
</template>
<script>
import QuickChat from './quick-chat'
import ProgressDia from './progress-dia'
import YejifenchengDia from './yejifencheng-dialog.vue'
import { hasPermisson } from '../../../project/src/constant/utils'

export default {
  components: {
    QuickChat,
    ProgressDia,
    YejifenchengDia,
  },
  props: {
    onConfirm: {
      type: Function,
      default: function () {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      radish: {},
      rid: '',
      project: {},
      pid: '',
      progresses: { 电话沟通: 1, 客户推荐: 2, 面试阶段: 3, 终面阶段: 4, offer谈判: 5, 离职管理: 6, 到岗: 7, 过保: 8 },
      progress: {},
      step: '',
      currentProgress: 1,
      logs: [],
      logOnly: false,
      timestamp: 0,
      role: ['推荐', 'offer反馈', '确认offer', '离职辅导', '未入职', '到岗', '过保', '未过保'],
      reportType: 'mapping',
      showIntoProject: false, // 推荐历史中，需要有加入项目
    }
  },
  methods: {
    hasPermisson() {
      return hasPermisson(this.project)
    },
    async getReport() {
      const { pid } = this
      if (this.reportType === 'report') {
        const loading = this.$loading({
          lock: true,
          text: '正在获取项目进展报告，请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        try {
          const res = await app.service('project').getProjectReport({
            pid: pid,
          })
          if (res && res.status === 'success' && res.data) {
            app.root.$refs.ProjectReportEditor.open({
              url: res.data.url,
              md5: res.data.md5,
              documentType: res.data && res.data.documentType,
              fileType: res.data && res.data.fileType,
              originalname: res.data && res.data.originalname,
            })
          } else this.$message.error(res.msg)
        } catch (e) {
          console.error(e)
          this.$message.error(`生成项目搜索进度报告出错`)
        }
        loading.close()
      } else {
        app.root.$refs.MappingReportChooseHeaderDialog.open(pid)
      }
    },
    openTrainingVideo() {
      app.root.$refs.TrainingVideoDialog.open('mapping')
    },
    removeBadge(log) {
      if (log.badge) log.badge = false
    },
    getStorage() {
      const storage = localStorage.getItem('radishProgressHistory')
      const obj = (storage && JSON.parse(storage)) || {}
      const time = obj[`${this.pid}${this.rid}`]
      if (!time) this.timestamp = 0
      else {
        const timestamp = new Date(time).getTime()
        this.timestamp = timestamp
      }
    },
    close() {
      const { logs } = this
      const time = logs[0] && logs[0].timestamp
      if (!time) return
      const storage = localStorage.getItem('radishProgressHistory')
      let obj = {}
      try {
        obj = (storage && JSON.parse(storage)) || {}
      } catch (e) {
        console.log(e)
      }

      obj[`${this.pid}${this.rid}`] = time
      localStorage.setItem('radishProgressHistory', JSON.stringify(obj))
    },
    async open(params) {
      const { rid, pid, logOnly } = params
      if (!rid) return this.$message.error('缺少radish')
      if (!pid) return this.$message.error('缺少project')
      this.rid = rid
      this.pid = pid
      if (logOnly) this.logOnly = logOnly
      this.getStorage()
      const res = await this.loadData()
      if (res) this.dialogVisible = true
    },
    async loadData() {
      // 获取人选
      const radishRes = await app.service('radish').simpleFetch({ _id: this.rid, fields: { 沟通日志: 0 } })
      if (radishRes.status == 'fail') {
        this.$message.error(radishRes.msg)
        return false
      } else if (radishRes.msg == 'nothave') {
        this.$message.warning('人选不存在')
        return false
      }
      this.radish = radishRes.data
      // 获取项目
      const project = await app.service('project').fetch(this.pid)
      if (!project) {
        this.$message.warning('项目不存在')
        return false
      }
      try {
        const pids = [project._id]
        const { data } = await this.$axios.post(`${window.host}/projects/newPipelines`, {
          pids,
        })
        const projectPipeline = data[0]
        Object.assign(project, projectPipeline)
      } catch (e) {
        console.error(e)
      }
      this.project = project
      // 获取进度
      const progressRes = await app.service('radish').getProgressStatus({ rid: this.rid, pid: this.pid })
      console.log(progressRes)
      if (progressRes.status == 'fail') {
        this.$message.error(progressRes.msg)
        return false
      }
      const progress = progressRes.data
      if (!progress.进度 || !progress.标签) {
        this.$message.error('未获取到进度')
        return false
      }
      // const progress = {
      //   进度: 'offer',
      //   标签: '离职辅导',
      // }
      this.currentProgress = this.progresses[progress.进度]
      this.progress = progress
      // 对应step
      switch (progress.标签) {
        case 'Call':
          this.step = '人才搜寻'
          break
        case '推荐':
          this.step = '职位推荐'
          break
        case '面试':
          this.step = '面试阶段'
          break
        case '终面':
        case 'offer谈判':
          this.step = 'offer谈判'
          break
        case '离职辅导':
          this.step = '离职管理'
          break
        case '到岗':
        case '过保':
          this.step = '开票催款'
          break
        default:
          this.step = '项目详情'
          break
      }
      // 获取日志
      const logRes = await app.service('radish').getProgressLog({ rid: this.rid, pid: this.pid })
      if (logRes.status == 'fail') {
        this.$message.error(logRes.msg)
        return false
      }
      this.logs = logRes.data

      const account = app.user.account
      this.logs.forEach((v) => {
        if (this.role.includes(v.type) && !v.title.includes(account)) {
          const time = new Date(v.timestamp).getTime()
          this.$set(v, 'badge', time > this.timestamp)
        }
      })
      return true
    },
    dotClass(k) {
      if (k < this.currentProgress) {
        return 'el-icon-success'
      } else if (k === this.currentProgress) {
        if (this.progress.isFail) return 'el-icon-error'
        return 'rpg-dot-blue'
      } else {
        return 'rpg-dot-gray'
      }
    },
    diaConfirm() {
      this.loadData()
      this.onConfirm()
    },
    showAll() {
      app.root.$refs.NewProjectProgressDialog.open(this.project, this.step)
    },
    openQuickChat() {
      // window.open(`${window.frontend}/#/radish-detail-blank/${this.rid}`, '_blank')
      this.$refs.QuickChat.open({ radish: this.radish, project: this.project })
    },
    showYejifenchengDia() {
      this.$refs.YejifenchengDia.open({ radish: this.radish, project: this.project })
    },
    yejiConfirm() {
      this.diaConfirm()
      // this.$refs.ProgressDia.open({ radish: this.radish, project: this.project, compName: 'OfferConfirm' })
    },
    showDia(compName) {
      this.$refs.ProgressDia.open({ radish: this.radish, project: this.project, compName })
    },
    showOffer() {
      this.showDia('OfferEdit')
      this.$nextTick(() => {
        this.$refs.ProgressDia.$refs.compt.type = 'view'
      })
    },
    reStart() {
      this.$confirm('确定要重启人选吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          // 重启
          await app.service('radish').reStartProgress({ rid: this.radish._id, pid: this.pid })
          this.diaConfirm()
        })
        .catch(() => {})
    },
    makePayDoc() {
      app.root.$refs.makePayDoc.open({ rid: this.rid, pid: this.pid, times: 'first' })
    },
    makePayDoc2() {
      app.root.$refs.makePayDoc.open({ rid: this.rid, pid: this.pid, times: 'second' })
    },
    formatStr(str) {
      return str.replace(/\n/g, '<br />')
    },
    async kaipiao() {
      const res = await app
        .service('radish')
        .modifyStatus({ rid: this.rid, pid: this.pid, status: { tag: this.progress.标签, detail: '开票中' } })
      if (res.status == 'success') {
        await app.service('company').updateFinanceFapiao({
          rid: this.rid,
          pid: this.pid,
          times: this.progress.标签 == '到岗' ? 'first' : 'second',
        })
        this.$message.success('操作成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    interviewCreateFinal() {
      this.$refs.ProgressDia.open({
        radish: this.radish,
        project: this.project,
        compName: 'InterviewCreate',
        defaultData: { isFinal: true },
      })
    },
    offerFeedbackGiveup() {
      this.$refs.ProgressDia.open({
        radish: this.radish,
        project: this.project,
        compName: 'OfferFeedback',
        defaultResult: '拒绝',
      })
    },
    genRepo() {
      app.root.$refs.reportMaker.init({ radish: this.radish._id })
    },
    cancelRecommend() {
      this.$confirm(`确定取消推荐吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await app.service('radish').deleteRecommend({ rid: this.radish._id, pid: this.pid })
          if (res.status == 'success') {
            this.diaConfirm()
            this.$message.success('取消成功')
          } else {
            this.$message.info(res.msg)
          }
        })
        .catch(() => {})
    },
    cancelInterview() {
      this.$confirm(`确定取消最近一次面试吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await app.service('radish').deleteInterview({ rid: this.radish._id, pid: this.pid })
          if (res.status == 'success') {
            this.diaConfirm()
            this.$message.success('取消成功')
          } else {
            this.$message.info(res.msg)
          }
        })
        .catch(() => {})
    },
    intoProject() {
      app.root.$refs.radishProDialog.show([this.radish], 'intoProject')
    },
  },
}
</script>
<style>
@import '../../static/css/progress.css';
</style>
<style>
.radish-progress-dot .el-badge__content.is-fixed.is-dot {
  right: 0px;
  top: 6px;
}
</style>
